import { render, staticRenderFns } from "./LandDegradationNeutrality.vue?vue&type=template&id=73f1c116&scoped=true"
import script from "./LandDegradationNeutrality.vue?vue&type=script&lang=js"
export * from "./LandDegradationNeutrality.vue?vue&type=script&lang=js"
import style1 from "./LandDegradationNeutrality.vue?vue&type=style&index=1&id=73f1c116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1c116",
  null
  
)

export default component.exports